import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "row align-items-center" }, [
        _createElementVNode("div", { class: "col-lg-8" }, [
          _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
            _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ])
            ]),
            _createElementVNode("div", {
              class: "progress w-100 rounded-pill",
              role: "progressbar",
              "aria-label": "Example 5px high",
              "aria-valuenow": "100",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"5px","background-color":"#eff2ff"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar rounded-pill",
                style: {"width":"100%"}
              })
            ]),
            _createElementVNode("span", { class: "ms-4" }, "359")
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
            _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ])
            ]),
            _createElementVNode("div", {
              class: "progress w-100 rounded-pill",
              role: "progressbar",
              "aria-label": "Example 5px high",
              "aria-valuenow": "90",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"5px","background-color":"#eff2ff"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar rounded-pill",
                style: {"width":"90%"}
              })
            ]),
            _createElementVNode("span", { class: "ms-4" }, "208")
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
            _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ])
            ]),
            _createElementVNode("div", {
              class: "progress w-100 rounded-pill",
              role: "progressbar",
              "aria-label": "Example 5px high",
              "aria-valuenow": "80",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"5px","background-color":"#eff2ff"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar rounded-pill",
                style: {"width":"80%"}
              })
            ]),
            _createElementVNode("span", { class: "ms-4" }, "124")
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
            _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ])
            ]),
            _createElementVNode("div", {
              class: "progress w-100 rounded-pill",
              role: "progressbar",
              "aria-label": "Example 5px high",
              "aria-valuenow": "70",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"5px","background-color":"#eff2ff"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar rounded-pill",
                style: {"width":"70%"}
              })
            ]),
            _createElementVNode("span", { class: "ms-4" }, "89")
          ]),
          _createElementVNode("div", { class: "d-flex align-items-center mb-0" }, [
            _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
              ])
            ]),
            _createElementVNode("div", {
              class: "progress w-100 rounded-pill",
              role: "progressbar",
              "aria-label": "Example 5px high",
              "aria-valuenow": "60",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              style: {"height":"5px","background-color":"#eff2ff"}
            }, [
              _createElementVNode("div", {
                class: "progress-bar rounded-pill",
                style: {"width":"60%"}
              })
            ]),
            _createElementVNode("span", { class: "ms-4" }, "4")
          ])
        ]),
        _createElementVNode("div", { class: "col-lg-4" }, [
          _createElementVNode("div", { class: "text-center mt-4 mt-lg-0" }, [
            _createElementVNode("h1", { class: "fs-40 mb-2" }, "4.28"),
            _createElementVNode("ul", { class: "ps-0 mb-3 list-unstyled d-flex gap-2 justify-content-center" }, [
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("i", { class: "ri-star-line text-light fs-30" })
              ])
            ]),
            _createElementVNode("span", { class: "ms-4" }, "of 3250 Reviews")
          ])
        ])
      ])
    ], -1)
  ]))]))
}